// desktop + mobile
import './pages/template-onboard-page';
import './pages/command-center-page';
import './pages/challenge-page';
import './pages/registration-page';
import './pages/join-page';
import './pages/creator-profile-page';
import './pages/point-page';
import './pages/nomination-page';
import './pages/map-page';
import './pages/ballot-page';
import './pages/cart-page';
import './pages/upload-page';
import './pages/admin-portal-page';
import './pages/bulk-reg-page';
import './pages/account/backpack-page';
import './pages/login-page';
import './pages/referral-redirect-page';
import './pages/account/folder-page';
import './pages/account/edit-creator-profile-page';
import './pages/account/view-creator-profiles-page';
import './pages/account/account-info-page';
import './pages/team-settings-page';
import './pages/error-403-page';
import './pages/error-404-page';
import './pages/discover-page';
import './pages/discover-details-page';
import './pages/printable-page';
import './pages/summary-page';
import './pages/city-radius-challenge-page';
import './pages/checkout-return-page';
import './pages/static-map-embed-page';
import './pages/challenge-leaderboard-view-page';
import './pages/challenge-photo-feed-view-page';
// mobile only
import './pages/mobile/admin-portal-page';

import { TemplateResult, html } from 'lit';

import { detectMobileViewport } from './helpers/device';
import { setFavicon } from './helpers/utils';

const desktopPageMap = new Map([
    ['', html`<backpack-page></backpack-page>`],
    ['#home', html`<backpack-page></backpack-page>`],
    ['#folder', html`<folder-page></folder-page>`],
    ['#template-onboard', html`<template-onboard-page></template-onboard-page>`],
    ['#command-center', html`<command-center-page></command-center-page>`],
    ['#challenge', html`<challenge-page></challenge-page>`],
    ['#hunt', html`<challenge-page></challenge-page>`],
    ['#guide', html`<challenge-page></challenge-page>`],
    ['#treasure-hunt', html`<challenge-page></challenge-page>`],
    ['#trivia', html`<challenge-page></challenge-page>`],
    ['#registration', html`<registration-page></registration-page>`],
    ['#summary', html`<summary-page></summary-page>`],
    ['#creator-profile', html`<creator-profile-page></creator-profile-page>`],
    ['#edit-creator-profile', html`<edit-creator-profile-page></edit-creator-profile-page>`],
    ['#view-creator-profiles', html`<view-creator-profiles-page></view-creator-profiles-page>`],
    ['#admin-portal', html`<admin-portal-page></admin-portal-page>`],
    ['#account', html`<account-info-page></account-info-page>`],
    ['#team-settings', html`<team-settings-page></team-settings-page>`],
    ['#login', html`<login-page></login-page>`],
    ['#point', html`<point-page></point-page>`],
    ['#form', html`<point-page></point-page>`], // for backwards compatibility with old links
    ['#map', html`<map-page></map-page>`],
    ['#ballot', html`<ballot-page></ballot-page>`],
    ['#nomination', html`<nomination-page></nomination-page>`],
    ['#cart', html`<cart-page></cart-page>`],
    ['#upload', html`<upload-page></upload-page>`],
    ['#internal-reg', html`<bulk-reg-page></bulk-reg-page>`],
    ['#discover', html`<discover-page></discover-page>`],
    ['#discover-details', html`<discover-details-page></discover-details-page>`],
    ['#print', html`<printable-page></printable-page>`],
    ['#static-map-embed', html`<static-map-embed-page></static-map-embed-page>`],
    ['#challenge-leaderboard', html`<challenge-leaderboard-view-page></challenge-leaderboard-view-page>`],
    ['#challenge-photo-feed', html`<challenge-photo-feed-view-page></challenge-photo-feed-view-page>`],
    ['#city-challenge', html`<city-radius-challenge-page></city-radius-challenge-page>`],
    ['#unauthorized', html`<error-403-page></error-403-page>`],
    ['#checkout-return', html`<checkout-return-page></checkout-return-page>`],
    ['#subscription-details', html`<subscription-details-page></subscription-details-page>`],
    ['#referral', html`<referral-redirect-page></referral-redirect-page>`],
]);

const mobilePageMap = new Map([
    ['', html`<backpack-page></backpack-page>`],
    ['#home', html`<backpack-page></backpack-page>`],
    ['#folder', html`<folder-page></folder-page>`],
    ['#template-onboard', html`<template-onboard-page></template-onboard-page>`],
    ['#command-center', html`<command-center-page></command-center-page>`],
    ['#challenge', html`<challenge-page></challenge-page>`],
    ['#hunt', html`<challenge-page></challenge-page>`],
    ['#guide', html`<challenge-page></challenge-page>`],
    ['#treasure-hunt', html`<challenge-page></challenge-page>`],
    ['#trivia', html`<challenge-page></challenge-page>`],
    ['#summary', html`<summary-page></summary-page>`],
    ['#registration', html`<registration-page></registration-page>`],
    ['#creator-profile', html`<creator-profile-page></creator-profile-page>`],
    ['#edit-creator-profile', html`<edit-creator-profile-page></edit-creator-profile-page>`],
    ['#view-creator-profiles', html`<view-creator-profiles-page></view-creator-profiles-page>`],
    ['#admin-portal', html`<admin-portal-page-mobile></admin-portal-page-mobile>`],
    ['#account', html`<account-info-page></account-info-page>`],
    ['#team-settings', html`<team-settings-page></team-settings-page>`],
    ['#login', html`<login-page></login-page>`],
    ['#point', html`<point-page></point-page>`],
    ['#form', html`<point-page></point-page>`], // for backwards compatibility with old links
    ['#map', html`<map-page></map-page>`],
    ['#ballot', html`<ballot-page></ballot-page>`],
    ['#nomination', html`<nomination-page></nomination-page>`],
    ['#cart', html`<cart-page></cart-page>`],
    ['#upload', html`<upload-page></upload-page>`],
    ['#internal-reg', html`<bulk-reg-page></bulk-reg-page>`],
    ['#discover', html`<discover-page></discover-page>`],
    ['#discover-details', html`<discover-details-page></discover-details-page>`],
    ['#print', html`<printable-page></printable-page>`],
    ['#static-map-embed', html`<static-map-embed-page></static-map-embed-page>`],
    ['#challenge-leaderboard', html`<challenge-leaderboard-view-page></challenge-leaderboard-view-page>`],
    ['#challenge-photo-feed', html`<challenge-photo-feed-view-page></challenge-photo-feed-view-page>`],
    ['#city-challenge', html`<city-radius-challenge-page></city-radius-challenge-page>`],
    ['#unauthorized', html`<error-403-page></error-403-page>`],
    ['#checkout-return', html`<checkout-return-page></checkout-return-page>`],
    ['#referral', html`<referral-redirect-page></referral-redirect-page>`],
    ['#subscription-details', html`<subscription-details-page></subscription-details-page>`]
]);

const NEW_APP_DEMO_URL = 'https://app.proxi.co/demo';

// adding anything to this will override the other places be careful
const urlPageMap = new Map([
    // uncomment localhost to test join page locally
    // ['localhost', html`<join-page></join-page>`],
    ['play.proxi.co', html`<join-page></join-page>`],
    ['betaplay.proxi.co', html`<join-page></join-page>`],
    ['mania.proxi.co', html`<city-radius-challenge-page></city-radius-challenge-page>`],
    ['refer.proxi.co', html`<referral-redirect-page></referral-redirect-page>`],
]);

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Router {
    static getContent() {
        // Get base information
        const hostname = window.location.hostname.toLowerCase();
        const path = window.location.pathname;
        const hash = window.location.hash;

        // First determine which page we're showing
        let pageName = '';
        let result: TemplateResult | undefined;

        // demo.proxi.co and #demo now live in the new app; keep old links and QR codes working.
        if (hostname === 'demo.proxi.co' || hash.startsWith('#demo')) {
            window.location.replace(`${NEW_APP_DEMO_URL}${window.location.search}`);
            return html``;
        }

        // 1. URL-based overrides (highest priority) | check if it is one of our special pages
        const urlOverride = urlPageMap.get(hostname);
        if (urlOverride) {
            result = urlOverride;
            // For URL overrides, we don't need a page name for title
        }
        // If no URL override, determine page name
        else {
            // 2. Determine page name from available sources

            // Path-based routing with query params (/r/xyz?view=challenge)
            if (path.startsWith('/r/')) {
                const viewParam = window.location.search
                    .substring(1)
                    .split('&')
                    .find(param => param.startsWith('view='));

                if (viewParam) {
                    pageName = `#${viewParam.split('=')[1]}`;
                }
            }

            // Hash-based routing (#challenge or #challenge?param=value)
            if (!pageName && hash) {
                // Extract base hash without query params
                pageName = hash.split('?')[0];

                // If no base hash but has view param in hash query
                if (pageName === '#' || pageName === '') {
                    const hashViewParam = hash.split('?')[1]?.split('&')
                        .find(param => param.startsWith('view='));

                    if (hashViewParam) {
                        pageName = `#${hashViewParam.split('=')[1]}`;
                    }
                }
            }

            // History state-based routing
            if (!pageName && history?.state?.page_name !== undefined && history?.state?.page_name !== '') {
                pageName = `#${history.state.page_name as string}`;
            }

            // 3. Bot detection for SEO (show discover page)
            const botPattern = '(googlebot/|bot|Googlebot-Mobile|embedly|iframely|Googlebot-Image|Google favicon|Mediapartners-Google|Google-Chat|GoogleOther|Google-Extended|Google-InspectionTool|Storebot-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|LineBot|KakaoTalk|Snap URL Preview Service|WeChat|SignalBot)';
            const isBotUser = new RegExp(botPattern, 'i').test(navigator.userAgent);
            if (isBotUser && !pageName) {
                result = html`<discover-page></discover-page>`;
                pageName = '#discover';
            }
            // If not bot or we have a pageName
            else {
                // 4. Look up the page component if not already determined
                const pageMap = detectMobileViewport() ? mobilePageMap : desktopPageMap;
                result = pageMap.get(pageName);

                // 5. Handle not found / fallback
                if (!result) {
                    result = html`<error-404-page></error-404-page>`;
                    pageName = '#not-found';
                }
            }
        }

        // Always update the page title
        Router.updatePageTitle(pageName);

        return result;
    }

    // Helper function for page titles
    static updatePageTitle(pageName: string) {
        if (document.title === 'Interactive Map Builder') {
            const titleMap = new Map([
                ['#home', 'Proxi Backpack'],
                ['#folder', 'Folder'],
                ['#template-onboard', 'Building Map...'],
                ['#command-center', 'Proxi Map'],
                ['#creator-profile', 'Creator Profile'],
                ['#edit-creator-profile', 'Edit Creator Profile'],
                ['#view-creator-profiles', 'View Creator Profiles'],
                ['#admin-portal', 'Proxi Editor'],
                ['#account', 'Proxi Account'],
                ['#team-settings', 'Workspace Settings'],
                ['#login', 'Login'],
                ['#demo', 'Demo'],
                ['#point', 'Edit Map Point'],
                ['#map', 'Interactive Map'],
                ['#upload', 'Upload'],
                ['#internal-reg', 'Bulk Registration'],
                ['#discover', 'Discover Proxi Guides'],
                ['#discover-details', 'Proxi Guide'],
                ['#print', 'Print Map'],
                ['#city-challenge', 'Main Street Mania Challenge'],
                ['#unauthorized', 'Unauthorized'],
            ]);

            setFavicon('images/favicon.svg');

            const title = titleMap.get(pageName);
            if (title) {
                document.title = title;
            }
        }
    }
}
